<template>
  <div class="regular-bonuses-wrapper" :class="{ mobile: isMobile }">
    <h3 class="regular-bonuses-title">
      {{ t('bonuses.regularBonusesInfoTitle') }}
    </h3>
    <AllBonusesGrid />
  </div>
</template>

<script setup lang="ts">
import AllBonusesGrid from '../../AllBonusesGrid/AllBonusesGrid.vue'

const { t } = useI18n()
const { isMobile } = usePlatform()
</script>

<style scoped>
.regular-bonuses-title {
  margin-top: 0;
  margin-bottom: var(--spacing-200);
  font: var(--desktop-text-xl-semibold);
}

.mobile {
  .regular-bonuses-title {
    max-width: 80%;
    margin: auto;
    margin-top: var(--spacing-200);

    font: var(--mobile-headline-semibold);
    text-align: center;
  }
}
</style>
